import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './jobProfiles.intl.json';

export const useJobProfilesIntl = () => useIntlModule(messages);
